import { createRootRoute, Outlet, useRouterState } from "@tanstack/react-router"
// import { TanStackRouterDevtools } from "@tanstack/router-devtools"
import { useEffect } from "react"
import { useAuthListener } from "@/features/auth"
import {
  CookieConsent,
  trackPageView,
  saveAttributionData,
  enrichAttributionWithGeo,
} from "@/features/analytics"
import { getEffectiveParams } from "@/features/config"
import { maybeRedirectToNativeBrowser } from "@/shared/lib/native-browser"
import { Toaster } from "@/shared/components/toaster"

function RootLayout() {
  useAuthListener()

  const pathname = useRouterState({ select: (s) => s.location.pathname })

  useEffect(() => {
    // May navigate away (Meta in-app webview → system browser) before anything else.
    maybeRedirectToNativeBrowser(getEffectiveParams())
    saveAttributionData()
    enrichAttributionWithGeo()
  }, [])

  useEffect(() => {
    trackPageView(pathname)
  }, [pathname])

  return (
    <>
      <CookieConsent />
      <Outlet />
      <Toaster />
      {/* {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />} */}
    </>
  )
}

export const rootRoute = createRootRoute({
  component: RootLayout,
})
